var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('h1',[_vm._v("Survey Not Found")]),_c('p',[_vm._v("A few things could have caused this:")]),_c('ol',[_c('li',[_vm._v("The URL you used isn't what was in your email")]),_c('li',[_vm._v("You have already completed this survey")]),_c('li',[_vm._v("We are no longer accepting submissions for this survey")])])])
}]

export { render, staticRenderFns }